import { observer } from 'mobx-react';
import { useTranslations } from 'next-intl';
import { formatPrice } from '@/utils/misc';
import { getBulkSaleRule, calculateSetPrice } from '@/utils/bulkDiscounts';

const Price = observer(({
  id,
  regularPrice,
  bulkDiscountRules,
}) => {
  const t = useTranslations('Product');

  const productData = {
    id,
    regular_price: regularPrice,
    bulk_discount_rules: bulkDiscountRules,
  };

  const renderBulkSaleInfo = () => {
    const rule = getBulkSaleRule(productData);
    if (!rule) return null;

    const { buy_quantity, get_quantity } = rule;
    const totalQuantity = buy_quantity + get_quantity;

    // Calculate total price based on discount rules
    const totalPrice = calculateSetPrice(rule, regularPrice);

    return (
      <div className="text-sm text-secondary-studio mt-1">
        {t('buy_x_for_y', { x: totalQuantity, y: formatPrice(totalPrice) })}
      </div>
    );
  };

  return (
    <>
      {renderBulkSaleInfo()}
    </>
  );
});

export default Price;
